import React from "react";
import FileItem from "../fileItem";

const FilesField = (props) => {
    const files = props.files || [];

    const onRemoveFile = (id) => {
        const newFiles = files.filter((file) => file.id !== id);
        props.onChange(newFiles);
    };

    const addFile = () => {
        return props.modal({
            name: "fileUpload",
            title: "Загрузка файла",
            propName: "file",
            isMultiple: props.isMultiple,
            uploadFile: props.uploadFile,
            action: (uploadedFiles) => {
                const newFiles = [...files, ...uploadedFiles];

                props.onChange(newFiles);
            },
        });
    };

    return (
        <div className="row form-group">
            <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                Файлы
            </label>
            <div className="col-sm-8 col-md-9">
                <div className="pb-2">
                    {files.map((file, i) => (
                        <div key={i} className="pb-2">
                            <FileItem
                                file={file}
                                withoutRemove={props.withoutRemove}
                                withoutDownload={props.withoutDownload}
                                onRemoveFile={onRemoveFile}
                            />
                        </div>
                    ))}
                </div>
                <div className="btn btn-secondary btn-sm" onClick={addFile}>
                    Добавить файл
                </div>
            </div>
        </div>
    );
};

export default FilesField;
